module.exports = __webpack_public_path__ + "static/promotional_so-d6c7442856a14f01c531.png";